import imageExists from 'image-exists';

export const getUserImageUrl = (
  id: string,
  orientation: 'rectangle' | 'square',
  size: 'small' | 'medium' | 'large' | 'xlarge'
) => {
  return `${process.env.REACT_APP_USER_HOST}/${id}/pictures/${orientation}_${size}.jpeg`;
};

export const getUserOgImageUrl = (
  id: string,
  orientation: 'rectangle' | 'square',
  size: 'small' | 'medium' | 'large' | 'xlarge'
) => {
  return `${process.env.REACT_APP_USER_HOST}/${id}/pictures/${orientation}_${size}.jpeg`;
};

export const getMentorImageUrl = (
  id: string,
  orientation: 'rectangle' | 'square',
  size: 'small' | 'medium' | 'large' | 'xlarge'
) => {
  return `${process.env.REACT_APP_USER_HOST}/${id}/shop/pictures/${orientation}_${size}.jpeg`;
};

export const getMeditationGroupImageUrl = (
  groupId: string,
  orientation: 'rectangle' | 'square' = 'square',
  size: 'small' | 'medium' | 'large' | 'xlarge' = 'medium'
) => {
  return `${process.env.REACT_APP_GROUP_STATIC_HOST}/${groupId}/pictures/${orientation}_${size}.jpeg`;
};

export type LibraryItemImageSize =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'original';

export const getLibraryItemImageUrl = (
  id: string,
  orientation: 'rectangle' | 'square',
  size: LibraryItemImageSize
) => {
  return `${process.env.REACT_APP_LIBRARY_ITEM_IMAGE}/${id}/pictures/tiny_${orientation}_${size}.jpeg`;
};

export const getArticleImageUrl = (
  id: string,
  orientation: 'rectangle' | 'square',
  size: 'small' | 'medium' | 'large' | 'xlarge' | 'original'
) => {
  return `${process.env.REACT_APP_LIBRARY_ITEM_IMAGE}/${id}/pictures/${orientation}_${size}.jpeg`;
};

export const getPlaylistImageUrl = (
  id: string,
  size: 'small' | 'medium' | 'large' | 'xlarge',
  background?: 'white' | 'black'
) => {
  return `${process.env.REACT_APP_PLAYLIST_IMAGE}/${id}/pictures/montage_${
    background ?? 'white'
  }_${size}.jpeg`;
};

export const getWorkshopImageUrl = (
  id: string,
  ownerId: string,
  orientation: 'rectangle' | 'square' | 'portrait',
  size: 'small' | 'medium' | 'large' | 'xlarge'
) => {
  let workshopImage = `${process.env.REACT_APP_USER_HOST}/${ownerId}/marketplace/shop/products/${id}/images/${orientation}_${size}.jpeg`;

  imageExists(workshopImage, (exists: boolean) => {
    if (!exists) {
      workshopImage = getUserImageUrl(
        ownerId,
        orientation === 'portrait' ? 'square' : orientation,
        size
      );
    }
  });

  return workshopImage;
};

interface TGetEventCoverImageUrl {
  id: string;
  shape: 'rectangle' | 'square';
  size: 'small' | 'medium' | 'large' | 'xlarge';
}

export const getEventCoverImageUrl = ({
  id,
  shape,
  size
}: TGetEventCoverImageUrl) => {
  return `${process.env.REACT_APP_EVENT_HOST}/${id}/pictures/${shape}_${size}.jpeg`;
};

interface GetTeacherMentoringIntroUrlParams {
  mentoringId: string;
}

export const getTeacherMentoringIntroUrl = ({
  mentoringId
}: GetTeacherMentoringIntroUrlParams) => {
  return `https://mentoring.insighttimer.com/${mentoringId}/shop/hls/index.m3u8`;
};

interface GetMarketplaceCourseImageParams {
  userId: string;
  courseId: string;
  size?: 'portrait' | 'rectangle' | 'square';
}

export const getMarketplaceCourseImage = ({
  userId,
  courseId,
  size = 'rectangle'
}: GetMarketplaceCourseImageParams) => {
  return `${process.env.REACT_APP_USER_HOST}/${userId}/uploads/marketplace/shop/products/${courseId}/images/${size}.jpeg`;
};

export const getMarketplaceCourseVideoCDNLink = ({
  userId,
  courseId
}: {
  userId: string;
  courseId: string;
}) =>
  `https://storage.googleapis.com/insight-timer-users/${userId}/uploads/marketplace/shop/products/${courseId}/video/video.m3u8`;
